import { render, staticRenderFns } from "./multi-user-access.vue?vue&type=template&id=031ae0be&scoped=true&"
import script from "./multi-user-access.vue?vue&type=script&lang=ts&"
export * from "./multi-user-access.vue?vue&type=script&lang=ts&"
import style0 from "./multi-user-access.vue?vue&type=style&index=0&id=031ae0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ae0be",
  null
  
)

export default component.exports